/**
 * Generated from ch5_p08.fla
 */
export function ch5_p08(this: Ich5_p08) {
	const bg = this.bg;
	if (!bg[0] && bg.elementFactory) {
		bg[0] = bg.elementFactory(0,undefined);
	}
	if (bg[0]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0.call(bg[0] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0);
		bg[0].x = 1024;
		bg[0].y = 273.5;
		bg[0].width = 2048.00;
		bg[0].height = 547.00;
		bg[0].alpha = 1;
		if (bg[0].onLayout) bg[0].onLayout();
	}
	if (!bg[1] && bg.elementFactory) {
		bg[1] = bg.elementFactory(1,undefined);
	}
	if (bg[1]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0copy.call(bg[1] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0copy);
		bg[1].x = 2825.75;
		bg[1].y = 273.5;
		bg[1].width = 1555.50;
		bg[1].height = 547.00;
		bg[1].alpha = 1;
		if (bg[1].onLayout) bg[1].onLayout();
	}
	const fg = this.fg;
	if (!fg[0] && fg.elementFactory) {
		fg[0] = fg.elementFactory(0,undefined);
	}
	if (fg[0]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile.call(fg[0] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile);
		fg[0].x = 766.25;
		fg[0].y = 558.25;
		fg[0].width = 1532.50;
		fg[0].height = 419.50;
		fg[0].alpha = 1;
		if (fg[0].onLayout) fg[0].onLayout();
	}
	if (!fg[1] && fg.elementFactory) {
		fg[1] = fg.elementFactory(1,undefined);
	}
	if (fg[1]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile.call(fg[1] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile);
		fg[1].x = 2298.75;
		fg[1].y = 558.25;
		fg[1].width = 1532.50;
		fg[1].height = 419.50;
		fg[1].alpha = 1;
		if (fg[1].onLayout) fg[1].onLayout();
	}
	if (!fg[2] && fg.elementFactory) {
		fg[2] = fg.elementFactory(2,undefined);
	}
	if (fg[2]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile.call(fg[2] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile);
		fg[2].x = 3831.25;
		fg[2].y = 558.25;
		fg[2].width = 1532.50;
		fg[2].height = 419.50;
		fg[2].alpha = 1;
		if (fg[2].onLayout) fg[2].onLayout();
	}
	if (!fg[3] && fg.elementFactory) {
		fg[3] = fg.elementFactory(3,undefined);
	}
	if (fg[3]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile.call(fg[3] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile);
		fg[3].x = 5363.75;
		fg[3].y = 558.25;
		fg[3].width = 1532.50;
		fg[3].height = 419.50;
		fg[3].alpha = 1;
		if (fg[3].onLayout) fg[3].onLayout();
	}
	const butterfly = this.butterfly;
	if (!butterfly[0] && butterfly.elementFactory) {
		butterfly[0] = butterfly.elementFactory(0,undefined);
	}
	if (butterfly[0]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1245.call(butterfly[0] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1245);
		butterfly[0].x = 1254.5;
		butterfly[0].y = 352.75;
		butterfly[0].width = 81.00;
		butterfly[0].height = 109.50;
		butterfly[0].alpha = 1;
		if (butterfly[0].onLayout) butterfly[0].onLayout();
	}
	if (!butterfly[1] && butterfly.elementFactory) {
		butterfly[1] = butterfly.elementFactory(1,undefined);
	}
	if (butterfly[1]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1246.call(butterfly[1] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1246);
		butterfly[1].x = 1254.5;
		butterfly[1].y = 352.75;
		butterfly[1].width = 81.00;
		butterfly[1].height = 109.50;
		butterfly[1].alpha = 1;
		if (butterfly[1].onLayout) butterfly[1].onLayout();
	}
	if (!butterfly[2] && butterfly.elementFactory) {
		butterfly[2] = butterfly.elementFactory(2,undefined);
	}
	if (butterfly[2]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1247.call(butterfly[2] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1247);
		butterfly[2].x = 1254.5;
		butterfly[2].y = 352.75;
		butterfly[2].width = 81.00;
		butterfly[2].height = 109.50;
		butterfly[2].alpha = 1;
		if (butterfly[2].onLayout) butterfly[2].onLayout();
	}
	if (!butterfly[3] && butterfly.elementFactory) {
		butterfly[3] = butterfly.elementFactory(3,undefined);
	}
	if (butterfly[3]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1248.call(butterfly[3] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1248);
		butterfly[3].x = 1254.5;
		butterfly[3].y = 352.75;
		butterfly[3].width = 81.00;
		butterfly[3].height = 109.50;
		butterfly[3].alpha = 1;
		if (butterfly[3].onLayout) butterfly[3].onLayout();
	}
	const xfg = this.xfg;
	if (!xfg[0] && xfg.elementFactory) {
		xfg[0] = xfg.elementFactory(0,undefined);
	}
	if (xfg[0]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundfrontbushes.call(xfg[0] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundfrontbushes);
		xfg[0].x = 243;
		xfg[0].y = 624.5;
		xfg[0].width = 486.00;
		xfg[0].height = 287.00;
		xfg[0].alpha = 1;
		if (xfg[0].onLayout) xfg[0].onLayout();
	}
	if (!xfg[1] && xfg.elementFactory) {
		xfg[1] = xfg.elementFactory(1,undefined);
	}
	if (xfg[1]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1.call(xfg[1] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1);
		xfg[1].x = 1679;
		xfg[1].y = 690.75;
		xfg[1].width = 584.00;
		xfg[1].height = 154.50;
		xfg[1].alpha = 1;
		if (xfg[1].onLayout) xfg[1].onLayout();
	}
	if (!xfg[2] && xfg.elementFactory) {
		xfg[2] = xfg.elementFactory(2,undefined);
	}
	if (xfg[2]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2.call(xfg[2] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2);
		xfg[2].x = 3353;
		xfg[2].y = 677.25;
		xfg[2].width = 743.00;
		xfg[2].height = 181.50;
		xfg[2].alpha = 1;
		if (xfg[2].onLayout) xfg[2].onLayout();
	}
	if (!xfg[3] && xfg.elementFactory) {
		xfg[3] = xfg.elementFactory(3,undefined);
	}
	if (xfg[3]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1.call(xfg[3] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1);
		xfg[3].x = 4846;
		xfg[3].y = 690.75;
		xfg[3].width = 584.00;
		xfg[3].height = 154.50;
		xfg[3].alpha = 1;
		if (xfg[3].onLayout) xfg[3].onLayout();
	}
	if (!xfg[4] && xfg.elementFactory) {
		xfg[4] = xfg.elementFactory(4,undefined);
	}
	if (xfg[4]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2.call(xfg[4] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2);
		xfg[4].x = 6520;
		xfg[4].y = 677.25;
		xfg[4].width = 743.00;
		xfg[4].height = 181.50;
		xfg[4].alpha = 1;
		if (xfg[4].onLayout) xfg[4].onLayout();
	}
	if (!xfg[5] && xfg.elementFactory) {
		xfg[5] = xfg.elementFactory(5,undefined);
	}
	if (xfg[5]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1.call(xfg[5] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1);
		xfg[5].x = 8002.55;
		xfg[5].y = 690.75;
		xfg[5].width = 584.00;
		xfg[5].height = 154.50;
		xfg[5].alpha = 1;
		if (xfg[5].onLayout) xfg[5].onLayout();
	}
	if (!xfg[6] && xfg.elementFactory) {
		xfg[6] = xfg.elementFactory(6,undefined);
	}
	if (xfg[6]) {
		ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2.call(xfg[6] as Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2);
		xfg[6].x = 9676.55;
		xfg[6].y = 677.25;
		xfg[6].width = 743.00;
		xfg[6].height = 181.50;
		xfg[6].alpha = 1;
		if (xfg[6].onLayout) xfg[6].onLayout();
	}
	const two = this.two;
	ch5_p08_two.call(this.two);
	two.x = 1216.75;
	two.y = 337.5;
	two.width = 2433.50;
	two.height = 337.00;
	two.alpha = 1.00;
	if (two.onLayout) two.onLayout();
	const Layer1267 = this.Layer1267;
	ch5_p08_Layer1267.call(this.Layer1267);
	Layer1267.x = 3964.25;
	Layer1267.y = 366;
	Layer1267.width = 2056.50;
	Layer1267.height = 288.00;
	Layer1267.alpha = 1.00;
	if (Layer1267.onLayout) Layer1267.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9 = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.x = 4742;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.y = 419.75;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.width = 376.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.height = 575.50;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7 = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.x = 3501;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.y = 349;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.width = 289.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.height = 392.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6 = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.x = 3034.5;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.y = 303.25;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.width = 252.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.height = 350.50;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5 = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.x = 1733.5;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.y = 357.5;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.width = 266.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.height = 322.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4 = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.x = 554;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.y = 313.25;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.width = 280.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.height = 377.50;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3 = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.x = 1216.5;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.y = 336;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.width = 289.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.height = 392.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1 = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.x = 348.25;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.y = 320.25;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.width = 314.50;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.height = 335.50;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middleground5_1 = this.hh_ch5_72dpi_p08psdAssetp08Middleground5_1;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_1.call(this.hh_ch5_72dpi_p08psdAssetp08Middleground5_1);
	hh_ch5_72dpi_p08psdAssetp08Middleground5_1.x = 1002;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_1.y = 328;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_1.width = 266.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_1.height = 322.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_1.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middleground5_1.onLayout) hh_ch5_72dpi_p08psdAssetp08Middleground5_1.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middleground5_2 = this.hh_ch5_72dpi_p08psdAssetp08Middleground5_2;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_2.call(this.hh_ch5_72dpi_p08psdAssetp08Middleground5_2);
	hh_ch5_72dpi_p08psdAssetp08Middleground5_2.x = 2814;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_2.y = 312;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_2.width = 266.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_2.height = 322.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_2.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middleground5_2.onLayout) hh_ch5_72dpi_p08psdAssetp08Middleground5_2.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middleground5_3 = this.hh_ch5_72dpi_p08psdAssetp08Middleground5_3;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_3.call(this.hh_ch5_72dpi_p08psdAssetp08Middleground5_3);
	hh_ch5_72dpi_p08psdAssetp08Middleground5_3.x = 4340.5;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_3.y = 311.5;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_3.width = 266.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_3.height = 322.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5_3.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middleground5_3.onLayout) hh_ch5_72dpi_p08psdAssetp08Middleground5_3.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1 = this.hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.call(this.hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1);
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.x = 4648;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.y = 354.25;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.width = 166.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.height = 196.50;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.onLayout) hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middleground5 = this.hh_ch5_72dpi_p08psdAssetp08Middleground5;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5.call(this.hh_ch5_72dpi_p08psdAssetp08Middleground5);
	hh_ch5_72dpi_p08psdAssetp08Middleground5.x = 2054.5;
	hh_ch5_72dpi_p08psdAssetp08Middleground5.y = 314;
	hh_ch5_72dpi_p08psdAssetp08Middleground5.width = 266.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5.height = 322.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middleground5.onLayout) hh_ch5_72dpi_p08psdAssetp08Middleground5.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2 = this.hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.call(this.hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2);
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.x = 1446;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.y = 346.75;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.width = 166.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.height = 196.50;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.onLayout) hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middleground5copy = this.hh_ch5_72dpi_p08psdAssetp08Middleground5copy;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy.call(this.hh_ch5_72dpi_p08psdAssetp08Middleground5copy);
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy.x = 90;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy.y = 354.25;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy.width = 166.00;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy.height = 196.50;
	hh_ch5_72dpi_p08psdAssetp08Middleground5copy.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middleground5copy.onLayout) hh_ch5_72dpi_p08psdAssetp08Middleground5copy.onLayout();
	const hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes = this.hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.call(this.hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes);
	hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.x = 126.75;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.y = 527;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.width = 253.50;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.height = 108.00;
	hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.alpha = 1.00;
	if (hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.onLayout) hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes.onLayout();
	const tractorOpen = this.tractorOpen;
	ch5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooduphood.call(this.tractorOpen);
	tractorOpen.x = 2916.5;
	tractorOpen.y = 355.75;
	tractorOpen.width = 273.00;
	tractorOpen.height = 174.50;
	tractorOpen.alpha = 1.00;
	if (tractorOpen.onLayout) tractorOpen.onLayout();
	const tractorClosed = this.tractorClosed;
	ch5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundtractorhooddownBody.call(this.tractorClosed);
	tractorClosed.x = 2920;
	tractorClosed.y = 355.75;
	tractorClosed.width = 280.00;
	tractorClosed.height = 174.50;
	tractorClosed.alpha = 1.00;
	if (tractorClosed.onLayout) tractorClosed.onLayout();
	const tractorWheels = this.tractorWheels;
	ch5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooddownwheels.call(this.tractorWheels);
	tractorWheels.x = 2907.75;
	tractorWheels.y = 416;
	tractorWheels.width = 278.50;
	tractorWheels.height = 111.00;
	tractorWheels.alpha = 1.00;
	if (tractorWheels.onLayout) tractorWheels.onLayout();
	const farmer = this.farmer;
	ch5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundFarmer.call(this.farmer);
	farmer.x = 2808.5;
	farmer.y = 484.5;
	farmer.width = 70.00;
	farmer.height = 162.50;
	farmer.alpha = 1.00;
	if (farmer.onLayout) farmer.onLayout();
	const cowNeutral = this.cowNeutral;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08cowneutral.call(this.cowNeutral);
	cowNeutral.x = 1643.5;
	cowNeutral.y = 452.5;
	cowNeutral.width = 277.00;
	cowNeutral.height = 192.00;
	cowNeutral.alpha = 1.00;
	if (cowNeutral.onLayout) cowNeutral.onLayout();
	const cowMooing = this.cowMooing;
	ch5_p08_hh_ch5_72dpi_p08psdAssetp08cowmooing.call(this.cowMooing);
	cowMooing.x = 1620.75;
	cowMooing.y = 438.75;
	cowMooing.width = 322.50;
	cowMooing.height = 219.50;
	cowMooing.alpha = 1.00;
	if (cowMooing.onLayout) cowMooing.onLayout();
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer0", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0copy(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer0copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_two(this: Ich5_p08_two) {
	if (this.setLayoutTexture) this.setLayoutTexture("two", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_Layer1267(this: Ich5_p08_Layer1267) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer1267", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9) {
	if (this.setLayoutTexture) this.setLayoutTexture("9", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7) {
	if (this.setLayoutTexture) this.setLayoutTexture("7", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6) {
	if (this.setLayoutTexture) this.setLayoutTexture("6", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5) {
	if (this.setLayoutTexture) this.setLayoutTexture("5", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4) {
	if (this.setLayoutTexture) this.setLayoutTexture("4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3) {
	if (this.setLayoutTexture) this.setLayoutTexture("3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1) {
	if (this.setLayoutTexture) this.setLayoutTexture("1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_1(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("5_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_2(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("5_2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_3(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_3) {
	if (this.setLayoutTexture) this.setLayoutTexture("5_3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("5copy_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5) {
	if (this.setLayoutTexture) this.setLayoutTexture("5", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("5copy_2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("5copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes) {
	if (this.setLayoutTexture) this.setLayoutTexture("bushes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooduphood(this: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooduphood) {
	if (this.setLayoutTexture) this.setLayoutTexture("hood", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundtractorhooddownBody(this: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundtractorhooddownBody) {
	if (this.setLayoutTexture) this.setLayoutTexture("Body", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooddownwheels(this: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooddownwheels) {
	if (this.setLayoutTexture) this.setLayoutTexture("wheels", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundFarmer(this: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundFarmer) {
	if (this.setLayoutTexture) this.setLayoutTexture("Farmer", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile) {
	if (this.setLayoutTexture) this.setLayoutTexture("groundtile", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08cowneutral(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08cowneutral) {
	if (this.setLayoutTexture) this.setLayoutTexture("neutral", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08cowmooing(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08cowmooing) {
	if (this.setLayoutTexture) this.setLayoutTexture("mooing", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1245(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1245) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer1245", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1246(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1246) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer1246", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1247(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1247) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer1247", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1248(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1248) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer1248", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bush1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bush2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundfrontbushes(this: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundfrontbushes) {
	if (this.setLayoutTexture) this.setLayoutTexture("frontbushes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p08Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p08Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p08Sprite extends Ich5_p08Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p08Text extends Ich5_p08Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p08Polygon extends Array<number> {
}
interface Ich5_p08 {
	readonly bg: Ich5_p08Array<Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0|Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0copy>;
	readonly fg: Ich5_p08Array<Ich5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile>;
	readonly butterfly: Ich5_p08Array<Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1245|Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1246|Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1247|Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1248>;
	readonly xfg: Ich5_p08Array<Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundfrontbushes|Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1|Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2>;
	readonly two: Ich5_p08_two;
	readonly Layer1267: Ich5_p08_Layer1267;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1;
	readonly hh_ch5_72dpi_p08psdAssetp08Middleground5_1: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_1;
	readonly hh_ch5_72dpi_p08psdAssetp08Middleground5_2: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_2;
	readonly hh_ch5_72dpi_p08psdAssetp08Middleground5_3: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_3;
	readonly hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1;
	readonly hh_ch5_72dpi_p08psdAssetp08Middleground5: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5;
	readonly hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2;
	readonly hh_ch5_72dpi_p08psdAssetp08Middleground5copy: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy;
	readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes;
	readonly tractorOpen: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooduphood;
	readonly tractorClosed: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundtractorhooddownBody;
	readonly tractorWheels: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooddownwheels;
	readonly farmer: Ich5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundFarmer;
	readonly cowNeutral: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08cowneutral;
	readonly cowMooing: Ich5_p08_hh_ch5_72dpi_p08psdAssetp08cowmooing;
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Layer0copy extends Ich5_p08Sprite {
}
interface Ich5_p08_two extends Ich5_p08Sprite {
}
interface Ich5_p08_Layer1267 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_1 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_2 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5_3 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middleground5copy extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooduphood extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundtractorhooddownBody extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p081psbAssetp08Middlegroundtractorhooddownwheels extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p081psbAssetp08MiddlegroundFarmer extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08groundtile extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08cowneutral extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08cowmooing extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1245 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1246 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1247 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ButterflyPNGSequenceLayer1248 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush1 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundbush2 extends Ich5_p08Sprite {
}
interface Ich5_p08_hh_ch5_72dpi_p08psdAssetp08ExtremeForegroundfrontbushes extends Ich5_p08Sprite {
}
